var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,i){return _c('div',{key:i,staticClass:"tag"},[_c('a',{attrs:{"href":tag.url}},[_vm._v(_vm._s(tag.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }